import { Brand } from './typings'

const lowes: Brand = {
  clientInfo: {
    displayName: 'Lowes',
    accountNumberLengths: [14, 16],
    footerDisplay: 'Lowes.com',
    footerLink: 'https://www.lowes.com/',
    applicationUrl:
      'https://www.lowes.com/u/register/creditapp?cardType=LAC&diy=true&clientCode=LOWES&sitecode=lwessplan',
    dsecApigeeClientId: {
      development: 'JWRbQ2Aa86knbNvwWgwGtgn1MaLn6ujY',
      production: 'tFbXGuAJXFy0PlRihRVjoxBUmVhHvXDL'
    },
    persistApigeeClientId: { development: '', production: '' },
    setpayApigeeClientId: {
      development: 'zrXmJIcrQKOThuaFFMegeIGELPBTBJbE',
      production: 'KnxWRo037DtHblPAmKJkJeGuEtATHPmr'
    },
    metaTagCardTitle: {
      en: 'Credit Card',
      es: 'Tarjeta de Crédito'
    },
    metaTagCardDescription: {
      en: `Log into your Lowes credit card account online to pay your bills, check your FICO score, sign up for paperless billing, and manage your account preferences`,
      es: `Ingrese a su cuenta de la Tarjeta de Crédito Lowes en línea para pagar sus facturas, revisar su puntuación FICO, inscribirse en facturas digitales y manejar su cuenta.`
    },
    languages: ['en', 'es'],
    vanityUrl: 'Lowes.com',
    hostname: 'lowes.syf.com',
    linkingRedirect: '',
    ivaKey: '54165421-a738-413d-ae7f-0c0df1dc87b9',
    hasMss: true,
    hasCpl: false,
    promoUrl: '',
    hasCplOldErrorCode: false,
    isMultiAccount: true,
    footerContent: {
      en: "Your Lowe's Visa® Rewards Card, MyLowe's Rewards Credit Card, or Lowe’s SetPay™ account is issued by Synchrony Bank. The Synchrony Bank Privacy Policies govern the use of the Lowe's Visa® Rewards Card, MyLowe's Rewards Credit Card, or Lowe’s SetPay™ account. The use of this site is governed by the use of the Synchrony Bank Online ** Privacy Policy, which is different from the privacy policy of Lowe's.",
      es: "Synchrony Bank emite su Tarjeta Lowe's Visa® Rewards, Tarjeta de crédito MyLowe’s Rewards, o cuenta Lowe’s SetPay™. La Política de Privacidad de Synchrony Bank rige el uso de la Tarjeta Lowe's Visa® Rewards, Tarjeta de crédito MyLowe’s Rewards, o cuenta Lowe’s SetPay™. El uso de este sitio se rige por el uso de la Política de privacidad en línea de Synchrony Bank, que es diferente de la Política de Privacidad de Lowe's."
    },
    phoneNumbers: {
      loan: '',
      plcc: '1-888-840-7651',
      dualcard: '1-800-508-2520',
      fraud: '1-800-508-2520',
      customerService: '1-866-869-4798'
    },
    iOSAppId: '457954781',
    androidApp: {
      id: '',
      author: '',
      title: '',
      image: ''
    },
    crossBorder: false,
    cplHeroBannerDisplayName: '',
    termsOfService: {
      en: '/essimages/cs/groups/ess_webasset/generic/@lowes/en/html/ess012848.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@lowes/es/html/ess012854.html'
    },
    onlinePrivacy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@lowes/en/html/ess012845.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@lowes/es/html/ess012851.html'
    },
    privacyPolicy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@lowes/en/html/ess012846.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@lowes/es/html/ess012852.html'
    },
    websiteUsage: {
      en: '/essimages/cs/groups/ess_webasset/generic/@lowes/en/html/ess012847.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@lowes/es/html/ess012853.html'
    },
    voice: {
      cardName: '',
      google: {
        termsAndConditionsLink: ''
      },
      alexa: {
        termsAndConditionsLink: ''
      }
    }
  },
  palette: {
    button: {
      primary: {
        text: '#FFFFFF',
        hover: '#036096'
      },
      secondary: {
        hover: '#cfdde5'
      },
      background: '#0471af'
    },
    field: {
      icon: '#0471AF',
      focus: '#34657F',
      label: '#024990'
    },
    progressStepBar: {
      fill: '#0471AF',
      label: '#0471AF'
    },
    progressBar: {
      complete: '#0471AF',
      error: '#c63527',
      inProgress: '#0072ad',
      background: '#e9eaeb'
    },
    checkbox: {
      background: '#024990',
      font: '#FFFFFF'
    },
    switch: { background: '' },
    heroBackground: '',
    bodyBackground: '#FFFFFF',
    iconBackground: '#0471AF',
    headerBackground: '#ffffff',
    modalBackground: '#F9F9F9',
    formBackground: '#f2f2f2',
    headerDivider: '#024990',
    footerDivider: '#f6f5f6',
    contrastingText: '#FFFFFF',
    bodyText: '#333333',
    languageSelector: '#004990',
    focus: '',
    link: '#024990',
    footer: {
      background: '#024990',
      text: '#FFFFFF',
      link: '#FFFFFF'
    }
  },
  images: {
    logo: {
      en: '/assets/lowes/logo.svg',
      es: '/assets/lowes/logo.svg'
    },
    hero: '/assets/lowes/background.png',
    heroBgDesktop: '',
    heroBgMobile: '',
    mainPromo: {
      en: '/assets/lowes/promo.svg',
      es: '/assets/lowes/promo_es.svg'
    },
    voiceCplLogo: ''
  }
}

export default lowes
